"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Analyze_exports = {};
__export(Analyze_exports, {
  default: () => Analyze_default
});
module.exports = __toCommonJS(Analyze_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.67188 8.58984C6.67188 8.44661 6.71745 8.32943 6.80859 8.23828C6.91276 8.13411 7.02995 8.08203 7.16016 8.08203H9.66016C9.80339 8.08203 9.92057 8.13411 10.0117 8.23828C10.1159 8.32943 10.168 8.44661 10.168 8.58984C10.168 8.72005 10.1159 8.83724 10.0117 8.94141C9.92057 9.03255 9.80339 9.07812 9.66016 9.07812H7.16016C7.02995 9.07812 6.91276 9.03255 6.80859 8.94141C6.71745 8.83724 6.67188 8.72005 6.67188 8.58984ZM6.67188 11.0898C6.67188 10.9466 6.71745 10.8294 6.80859 10.7383C6.91276 10.6341 7.02995 10.582 7.16016 10.582H13.8398C13.9701 10.582 14.0807 10.6341 14.1719 10.7383C14.276 10.8294 14.3281 10.9466 14.3281 11.0898C14.3281 11.2201 14.276 11.3372 14.1719 11.4414C14.0807 11.5326 13.9701 11.5781 13.8398 11.5781H7.16016C7.02995 11.5781 6.91276 11.5326 6.80859 11.4414C6.71745 11.3372 6.67188 11.2201 6.67188 11.0898ZM7.16016 13.082C7.02995 13.082 6.91276 13.1341 6.80859 13.2383C6.71745 13.3294 6.67188 13.4466 6.67188 13.5898C6.67188 13.7201 6.71745 13.8372 6.80859 13.9414C6.91276 14.0326 7.02995 14.0781 7.16016 14.0781H13C13.1432 14.0781 13.2604 14.0326 13.3516 13.9414C13.4557 13.8372 13.5078 13.7201 13.5078 13.5898C13.5078 13.4466 13.4557 13.3294 13.3516 13.2383C13.2604 13.1341 13.1432 13.082 13 13.082H7.16016ZM8 3.16016H5.5C5.04427 3.16016 4.65365 3.32292 4.32812 3.64844C4.0026 3.97396 3.83984 4.37109 3.83984 4.83984V16.5C3.83984 16.9557 4.0026 17.3464 4.32812 17.6719C4.65365 17.9974 5.04427 18.1602 5.5 18.1602H15.5C15.9557 18.1602 16.3464 17.9974 16.6719 17.6719C16.9974 17.3464 17.1602 16.9557 17.1602 16.5V4.83984C17.1602 4.37109 16.9974 3.97396 16.6719 3.64844C16.3464 3.32292 15.9557 3.16016 15.5 3.16016H13V4C13 4.02604 13 4.05208 13 4.07812C13 4.10417 12.9935 4.13672 12.9805 4.17578H15.5C15.6823 4.17578 15.8385 4.24089 15.9688 4.37109C16.099 4.5013 16.1641 4.65755 16.1641 4.83984V16.5C16.1641 16.6823 16.099 16.8385 15.9688 16.9688C15.8385 17.099 15.6823 17.1641 15.5 17.1641H5.5C5.31771 17.1641 5.16146 17.099 5.03125 16.9688C4.90104 16.8385 4.83594 16.6823 4.83594 16.5V4.83984C4.83594 4.65755 4.90104 4.5013 5.03125 4.37109C5.16146 4.24089 5.31771 4.17578 5.5 4.17578H8.01953C8.00651 4.13672 8 4.10417 8 4.07812C8 4.05208 8 4.02604 8 4V3.16016ZM12.8242 4C12.8242 4.0651 12.7982 4.1237 12.7461 4.17578C12.707 4.22786 12.6549 4.25391 12.5898 4.25391H8.41016C8.34505 4.25391 8.28646 4.22786 8.23438 4.17578C8.19531 4.1237 8.17578 4.0651 8.17578 4V3.16016C8.17578 3.09505 8.19531 3.04297 8.23438 3.00391C8.28646 2.95182 8.34505 2.92578 8.41016 2.92578H12.5898C12.6549 2.92578 12.707 2.95182 12.7461 3.00391C12.7982 3.04297 12.8242 3.09505 12.8242 3.16016V4ZM8.41016 1.91016C8.07161 1.91016 7.77865 2.03385 7.53125 2.28125C7.28385 2.52865 7.16016 2.82161 7.16016 3.16016V4C7.16016 4.35156 7.28385 4.65104 7.53125 4.89844C7.77865 5.13281 8.07161 5.25 8.41016 5.25H12.5898C12.9284 5.25 13.2214 5.13281 13.4688 4.89844C13.7161 4.65104 13.8398 4.35156 13.8398 4V3.16016C13.8398 2.82161 13.7161 2.52865 13.4688 2.28125C13.2214 2.03385 12.9284 1.91016 12.5898 1.91016H8.41016Z",
      fill: "currentColor"
    }
  )
);
const SvgAnalyze = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Analyze_default = SvgAnalyze;
